module.exports = __webpack_public_path__ + "img/kv.e90d466d.png";